
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/attributes",
      function () {
        return require("private-next-pages/products/attributes.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/attributes"])
      });
    }
  